import React, { useEffect, useState, useContext } from "react";
import "./transactions.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { LanguageContext } from "../../Components/LanguageContext";
import translations from "./translation.json";
import { axiosInstance } from "../../axiosInstance";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";

export function Transactions() {
  const [selectedDate, setSelectedDate] = useState("");
  const [recentFirst, setRecentFirst] = useState(false);

  const { language } = useContext(LanguageContext);
  const [activeTab, setActiveTab] = useState("withdrawn");
  const [transaction, setTransaction] = useState([]);
  const [withdraw, setWithDraw] = useState([]);

  const location = useLocation();

  useEffect(() => {
    fetchTransactions();
    fetchWithdrawals();
  }, []);

  const fetchTransactions = async () => {
    try {
      const response = await axiosInstance.get("/agent/agent-transaction/");
      setTransaction(response.data.data || []);
    } catch (error) {
      console.log("Error while fetching transactions", error);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "--";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const fetchWithdrawals = async () => {
    try {
      const response = await axiosInstance.get("/agent/withdraw-list/");
      setWithDraw(response.data.data);
    } catch (error) {
      console.log("Error while fetching withdrawals", error);
    }
  };

  const withdrawnColumns = [
    {
      id: "Date",
      label: translations[language].date,
      minWidth: 150,
      align: "center",
    },
    {
      id: "Withdrawnpoints",
      label: translations[language].withdrawn_points,
      minWidth: 100,
      align: "center",
    },
    // {
    //   id: "RemainingPoints",
    //   label: translations[language].remaining_points,
    //   minWidth: 170,
    //   align: "center",
    // },
    {
      id: "payment_status",
      label: translations[language].payment_status,
      minWidth: 170,
      align: "center",
    },
    {
      id: "created_at",
      label: translations[language].created_at,
      minWidth: 170,
      align: "center",
    },
    {
      id: "updated_at",
      label: translations[language].updated_at,
      minWidth: 170,
      align: "center",
    },
  ];

  function handleWithdrawn() {
    const filteredData = selectedDate
      ? withdraw.filter(
          (drawn) => drawn.updated_at.slice(0, 10) === selectedDate
        )
      : withdraw;
    //  for recentfirst simply reverse the array of data getting from api
    const displayData = recentFirst
      ? [...filteredData].reverse()
      : filteredData;

    const withdrawnRows = displayData.map((drawn) => ({
      Date: drawn.updated_at.slice(0, 10) || "--",
      Withdrawnpoints: drawn.points_to_withdraw || "0",
      // RemainingPoints: drawn.remaining_points || "0",
      PaymentStatus: drawn.payment_status || "Pending",
      CreatedAt: formatDate(drawn.created_at),
      UpdatedAt: formatDate(drawn.updated_at),
    }));

    return (
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer className="tableContainer">
          <Table stickyHeader aria-label="withdrawn table">
            <TableHead>
              <TableRow>
                {withdrawnColumns.map((column) => (
                  <TableCell
                    className="trasactiontableHeader"
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {withdrawnRows.length > 0 ? (
                withdrawnRows.map((row, index) => (
                  <TableRow hover tabIndex={-1} key={index}>
                    {withdrawnColumns.map((column) => {
                      let cellColor = "#716466"; // default color

                      // Color logic for payment status
                      if (column.id === "payment_status") {
                        if (row.PaymentStatus.toLowerCase() === "pending") {
                          cellColor = "#FFA500"; // Orange
                        } else if (
                          row.PaymentStatus.toLowerCase() === "approved"
                        ) {
                          cellColor = "#28a745"; // Green
                        } else if (
                          row.PaymentStatus.toLowerCase() === "rejected"
                        ) {
                          cellColor = "#dc3545"; // Red
                        }
                      }

                      // Color for Withdrawnpoints
                      if (column.id === "Withdrawnpoints") {
                        cellColor = "#AC3047";
                      }

                      // Display correct field based on column id
                      let displayValue = "--";
                      switch (column.id) {
                        case "Date":
                          displayValue = row.Date;
                          break;
                        case "Withdrawnpoints":
                          displayValue = row.Withdrawnpoints;
                          break;
                        case "payment_status":
                          displayValue = row.PaymentStatus;
                          break;
                        case "created_at":
                          displayValue = row.CreatedAt;
                          break;
                        case "updated_at":
                          displayValue = row.UpdatedAt;
                          break;
                        default:
                          displayValue = "--";
                      }

                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          className="trasactiontableBody"
                          sx={{ color: cellColor }}
                        >
                          {displayValue}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={withdrawnColumns.length} align="center">
                    Record not found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }

  const earnedColumns = [
    { id: "id", label: "Trasaction ID", minWidth: 100, align: "center" },
    {
      id: "promo_code_used_by",
      label: "Promo Code Used By",
      minWidth: 200,
      align: "center",
    },
    {
      id: "points",
      label: translations[language].earned_points,
      minWidth: 100,
      align: "center",
    },
    {
      id: "promo_code",
      label: "Promo Code ID",
      minWidth: 150,
      align: "center",
    },
    {
      id: "created_at",
      label: translations[language].date,
      minWidth: 170,
      align: "center",
    },
  ];

  function handleEarnedPoints() {
    const filteredData = selectedDate
      ? transaction.filter((t) => t.created_at.slice(0, 10) === selectedDate)
      : transaction;

    const displayData = recentFirst
      ? [...filteredData].reverse()
      : filteredData;

    const earnedRows = displayData.map((earned) => ({
      id: earned.id || "--",
      promo_code_used_by: earned.promo_code_used_by || "--",
      points: earned.points || "0",
      promo_code: earned.promo_code || "--",
      created_at: formatDate(earned.created_at) || "--",
    }));

    return (
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer className="tableContainer">
          <Table stickyHeader aria-label="earned table">
            <TableHead>
              <TableRow>
                {earnedColumns.map((column) => (
                  <TableCell
                    className="trasactiontableHeader"
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {earnedRows.length > 0 ? (
                earnedRows.map((row, index) => (
                  <TableRow hover tabIndex={-1} key={index}>
                    {earnedColumns.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        className="trasactiontableBody"
                        sx={{
                          color: column.id === "points" ? "#007D1F" : "#716466",
                        }}
                      >
                        {row[column.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={earnedColumns.length} align="center">
                    Record not found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    );
  }

  return (
    <div className="trasactionContainer">
      <div className="container">
        <div className="trasactionGrid">
          <div className="trasactionMenu">
            <span
              onClick={() => setActiveTab("withdrawn")}
              className={activeTab === "withdrawn" ? "active-tab" : ""}
            >
              {translations[language].withdrawn_points}
            </span>
            <span
              onClick={() => setActiveTab("earned")}
              className={activeTab === "earned" ? "active-tab" : ""}
            >
              {translations[language].earned_points}
            </span>
          </div>
        </div>
        {/* showing content here for selected tabs */}
        <div>
          {activeTab === "withdrawn"
            ? handleWithdrawn()
            : activeTab === "earned"
            ? handleEarnedPoints()
            : null}
        </div>
      </div>
    </div>
  );
}
